import { makeStyles } from '~/theme';

export const useStyles = makeStyles()((theme) => ({
  btn: {
    height: '100%',
    textTransform: 'none',
    color: theme.palette.text.primary,
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}));
